import { TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import { toast } from "react-toastify";
import { DateTimeField, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

let userToken = localStorage.getItem("userToken");

export default function EditPromo({ itemToEdit, setItemToEdit, endpoint, refresh, setRefresh }) {
  const [input, setInput] = useState();
  const [image, setImage] = useState(null);
  const [btnImage, setBtnImage] = useState(null);
  const [mobileBgImage, setMobileBgImage] = useState(null);

  const hiddenFileInput = useRef();
  const hiddenFileInput2 = useRef();
  const hiddenFileInput3 = useRef();

  const ref = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setItemToEdit({});
      setInput(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (Object.keys(itemToEdit).length > 0) {
        try {
          const response = await fetch(`${API}/${endpoint}/${itemToEdit.id}?populate=*`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken}`,
            },
            method: "GET",
          });
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          const res = await response.json();
          setInput(res.data.attributes);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }

    fetchData();
  }, [itemToEdit]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };

  const handleBtnImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setBtnImage(file);
    }
  };

  const handleMobileBgImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setMobileBgImage(file);
    }
  };

  const handleInputChange = (field, value) => {
    setInput({
      ...input,
      [field]: value,
    });
  };

  const uploadImage = async (file) => {
    const imageFormData = new FormData();
    imageFormData.append("files", file);

    const response = await fetch(`${API}/upload`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      method: "POST",
      body: imageFormData,
    });

    const result = await response.json();
    return result[0]?.url;
  };

  const saveChanges = async () => {
    try {
      const updatedData = { ...input };

      if (image) {
        const imageUrl = await uploadImage(image);
        updatedData.bg = imageUrl;
      }

      if (btnImage) {
        const btnImageUrl = await uploadImage(btnImage);
        updatedData.btnBg = btnImageUrl;
      }
 
      if (mobileBgImage) {
        const mobileBgImageUrl = await uploadImage(mobileBgImage);
        updatedData.mobileBg = mobileBgImageUrl;
      }

      const formData = new FormData();
      formData.append("data", JSON.stringify(updatedData));

      const response = await fetch(`${API}/${endpoint}/${itemToEdit.id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      });

      if (response.ok) {
        setRefresh(!refresh);
        setItemToEdit({});
        setInput(null);
        setImage(null);
        setBtnImage(null);
        setMobileBgImage(null);
        toast("Updated Successfully", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "success",
        });
        if (hiddenFileInput.current) {
          hiddenFileInput.current.value = "";
        }
        if (hiddenFileInput2.current) {
          hiddenFileInput2.current.value = "";
        }
        if (hiddenFileInput3.current) {
          hiddenFileInput3.current.value = "";
        }
      } else {
        const errorData = await response.json();
        console.error("Error updating entry:", errorData);
        toast("Error updating entry", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast("Error updating entry", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#00000020",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: 99999999,
        top: 0,
        left: 0,
        opacity: Object.keys(itemToEdit).length > 0 ? 1 : 0,
        visibility: Object.keys(itemToEdit).length > 0 ? "visible" : "hidden",
        transition: "0.3s",
      }}
      className="flex">
      <div
        ref={ref}
        style={{
          width: "65%",
          minWidth: 880,
          maxWidth: 1100,
          minheight: 560,
          backgroundColor: "#fff",
          borderRadius: 15,
          transition: "0.3s",
          padding: "40px 15px",
        }}>
        {input && (
          <div
            className="fadeIn"
            style={{
              marginTop: 10,
              marginBottom: 20,
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
            }}>
            <div style={{ width: "100%", display: "flex" }}>
              <div style={{ width: "50%", height: "100%" }}>
                <TextField
                  label="Title"
                  sx={{ width: "90%" }}
                  size="small"
                  value={input.title}
                  onChange={(e) => handleInputChange("title", e.target.value)}
                />
                <TextField
                  label="Description"
                  sx={{ width: "90%", mt: 2, mb: 2 }}
                  size="small"
                  multiline
                  rows={5}
                  value={input.desc}
                  onChange={(e) => handleInputChange("desc", e.target.value)}
                />
              </div>
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 10,
                }}>
                <div
                  style={{
                    border: "dashed",
                    borderWidth: 1,
                    borderColor: "grey",
                    height: 135,
                    marginTop: 1,
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                  onClick={() => hiddenFileInput.current.click()}>
                  {image ? (
                    <img
                      src={URL.createObjectURL(image)}
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      src={
                        input.bg
                          ? SERVER_DOMAIN + input.bg
                          : require("../../assets/icons/add-image.png")
                      }
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                        marginBottom: 5,
                      }}
                    />
                  )}
                  <p style={{ color: "#888", fontSize: 13 }}>
                    Click here to edit Promotion Background
                  </p>
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleImageChange}
                    ref={hiddenFileInput}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            </div>

            <div
              className="flex"
              style={{
                width: "100%",
                marginTop: 10,
                justifyContent: "space-between",
                gap: 10,
              }}>
              <div style={{ width: "50%" }}>
                <TextField
                  label="Button Link"
                  sx={{ width: "90%" }}
                  size="small"
                  value={input.btnL}
                  onChange={(e) => handleInputChange("btnL", e.target.value)}
                />

                <div
                  style={{
                    margin: "10px auto",
                    border: "dashed",
                    borderWidth: 1,
                    borderColor: "grey",
                    height: 135,
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                  onClick={() => hiddenFileInput2.current.click()}>
                  {btnImage ? (
                    <img
                      src={URL.createObjectURL(btnImage)}
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      src={
                        input.btnBg
                          ? SERVER_DOMAIN + input.btnBg
                          : require("../../assets/icons/add-image.png")
                      }
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                        marginBottom: 5,
                      }}
                    />
                  )}
                  <p style={{ color: "#888", fontSize: 13 }}>
                    Click here to edit Button Background
                  </p>
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleBtnImageChange}
                    ref={hiddenFileInput2}
                    style={{ display: "none" }}
                  />
                </div>

                <div
                  style={{
                    margin: "10px auto",
                    border: "dashed",
                    borderWidth: 1,
                    borderColor: "grey",
                    height: 135,
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                  onClick={() => hiddenFileInput3.current.click()}>
                  {mobileBgImage ? (
                    <img
                      src={URL.createObjectURL(mobileBgImage)}
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      src={
                        input.mobileBg
                          ? SERVER_DOMAIN + input.mobileBg
                          : require("../../assets/icons/add-image.png")
                      }
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                        marginBottom: 5,
                      }}
                    />
                  )}
                  <p style={{ color: "#888", fontSize: 13 }}>
                    Click here to edit Mobile Background
                  </p>
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleMobileBgImageChange}
                    ref={hiddenFileInput3}
                    style={{ display: "none" }}
                  />
                </div>
              </div>

              <div
                className="flex-col"
                style={{
                  width: "50%",
                  alignItems: "flex-start",
                  paddingLeft: 20,
                }}>
                <h3>Start Date & Time</h3>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimeField
                    sx={{ width: "60%", mt: 1 }}
                    label=""
                    defaultValue={dayjs()}
                    format="DD/MM/YYYY HH:mm"
                    value={dayjs(input.startsAt)}
                    onChange={(v) => setInput({ ...input, startsAt: v })}
                  />
                </LocalizationProvider>
                <h3 className="mt-6">End Date & Time</h3>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimeField
                    sx={{ width: "60%", mt: 1 }}
                    label=""
                    defaultValue={dayjs(input.endsAt)}
                    format="DD/MM/YYYY HH:mm"
                    onChange={(v) => setInput({ ...input, endsAt: v })}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>
        )}

        <div className="submitBTN" style={{ margin: "0 auto", marginTop: 0 }} onClick={saveChanges}>
          Save Changes
        </div>
      </div>
    </div>
  );
}
